import QueryParamsUtils from './query-params-utils';

export function buildLessonUrl(serializedParams: string): string {
  return `/learning/lesson.html?q=${QueryParamsUtils.hashQueryParams(serializedParams)}`;
}



// WEBPACK FOOTER //
// ./ts/app/shared/helpers/lesson-url.helpers.ts